<section class="flex h-full min-h-0 flex-col">
  @let context = thread || api.selectedContext(); @let friend = context ?
  (context.sender._id === userId ? context.receiver : context.sender) :
  undefined;
  <app-discussion-panel-header
    [threadView]="true"
    [friend]="friend"
    [friendOnline]="!!friend && api.peers.visible(threadId, friend._id)"
    [title]="
      friend
        ? friend.username || ('DISCUSSION.DELETED_USER' | translate)
        : ('DISCUSSIONS.LOADING' | translate)
    "
    [subtitle]="
      context
        ? ((context.sender._id === userId
            ? 'DISCUSSIONS.SENT'
            : 'DISCUSSIONS.RECEIVED'
          ) | translate) +
          ' · ' +
          (context.work.title ||
            ('DISCUSSION.HISTORICAL_TITLE_MISSING' | translate))
        : ''
    "
    [scrolled]="scrolled"
    [detailsDisabled]="!thread"
    [detailsLoading]="openingWork"
    (back)="api.showList(true)"
    (closePanel)="api.close()"
    (details)="openWork()"
  >
    @if (thread?.blockedByMe) {
    <button
      type="button"
      class="min-w-0 truncate px-1 py-0.5 text-xs underline text-grey dark:text-lightGrey"
      [disabled]="blocking"
      (click)="setBlocked(false)"
    >
      {{ "DISCUSSION.UNBLOCK" | translate: {name: friend?.username} }}
    </button>
    } @else {
    <button
      type="button"
      class="min-w-0 truncate px-1 py-0.5 text-xs underline text-grey dark:text-lightGrey"
      [disabled]="!thread || blocking || reporting"
      (click)="blockRequested.emit()"
    >
      {{ "DISCUSSION.BLOCK" | translate: {name: friend?.username} }}
    </button>
    }
  </app-discussion-panel-header>
  @if (error) {
  <p
    class="!m-0 px-2 py-1 text-sm text-form-error dark:text-form-errorLight"
    role="alert"
  >
    {{ error | translate }}
    <button type="button" class="underline" (click)="retry()">
      {{ "DISCUSSION.RETRY" | translate }}
    </button>
  </p>
  } @if (loading) {
  <app-discussion-loading></app-discussion-loading>
  } @if (thread) {
  <app-discussion-thread
    class="block flex-1 min-h-0"
    [entries]="entries"
    [participants]="[thread.sender, thread.receiver]"
    [userId]="userId"
    [recipient]="recipient"
    [canReply]="thread.canReply"
    [readOnlyReason]="readOnlyReason()"
    [suggestions]="suggestions"
    [hasMore]="before !== undefined"
    [loadingMore]="loadingMore"
    [automaticPagination]="!error"
    [sending]="sending"
    [deleting]="deleting"
    [sentRevision]="sentRevision"
    [unreadAfter]="unreadAfter"
    [originDate]="thread.additionDate"
    [locale]="locale"
    [workType]="thread.work.type"
    [typingVisible]="typing.visible()"
    [friendOnline]="!!friend && api.peers.visible(threadId, friend._id)"
    [peerReadSequence]="peerReadSequence"
    (typing)="typing.input($event)"
    (sendMessage)="send($event)"
    (removeMessage)="remove($event)"
    (reportMessage)="showReport($event)"
    (openWork)="openWork($event)"
    (loadMore)="older()"
    (scrolled)="scrolled = $event"
  >
    <app-discussion-reactions
      #originalReactions
      targetKey="comment"
      discussionOrigin
      data-discussion-anchor="comment"
      class="mb-2"
      [class]="
        thread.sender._id === userId ? 'tablet:ml-[66px]' : 'tablet:mr-[66px]'
      "
      [participants]="[thread.sender, thread.receiver]"
      [userId]="userId"
      [ownMessage]="thread.sender._id === userId"
      [enabled]="
        thread.canReply &&
        !!thread.comment &&
        !thread.commentModeratedAt &&
        !deleting
      "
      [actionsEnabled]="
        !!thread.comment && !thread.commentModeratedAt && !deleting
      "
    >
      <article
        class="flow-root rounded-2xl border border-borders-light dark:border-borders-darker bg-whitepale dark:bg-blacker p-1.5 mobile:p-2"
      >
        <div
          class="flex items-center gap-1 mb-1 text-sm text-grey dark:text-lightGrey"
        >
          <app-user-avatar
            [name]="thread.sender.username"
            [picture]="thread.sender.picture"
            [size]="28"
            [online]="api.peers.visible(threadId, thread.sender._id)"
          ></app-user-avatar
          ><span
            ><strong>{{
              thread.sender.username || ("DISCUSSION.DELETED_USER" | translate)
            }}</strong>
          </span>
        </div>
        <button
          type="button"
          class="flex w-full min-w-0 items-center gap-1.5 rounded-xl border border-borders-light dark:border-borders-darker bg-white dark:bg-black p-1.25 text-left focus-visible:outline-primary enabled:hover:border-grey dark:enabled:hover:border-lightGrey disabled:cursor-default"
          [disabled]="openingWork || !thread.work.available"
          [attr.aria-label]="
            ('DISCUSSIONS.DETAILS' | translate) + ' : ' + thread.work.title
          "
          (click)="openWork()"
        >
          @if (thread.work.cover && !coverFailed) {
          <img
            [src]="imagesDomain + '/' + thread.work.type + thread.work.cover"
            alt=""
            width="48"
            height="72"
            class="h-[72px] w-[48px] shrink-0 rounded-lg object-cover"
            loading="lazy"
            (error)="coverFailed = true"
          />
          }
          <span class="min-w-0">
            <span
              class="block font-title text-m leading-tight text-black dark:text-white [overflow-wrap:anywhere]"
            >
              {{
                thread.work.title ||
                  ("DISCUSSION.HISTORICAL_TITLE_MISSING" | translate)
              }}
            </span>
            @if (thread.work.year) {
            <span class="block mt-0.5 text-sm text-grey dark:text-lightGrey">{{
              thread.work.year
            }}</span>
            }
          </span>
        </button>
        @if (thread.commentModeratedAt) {
        <span class="block mt-1.5 italic text-grey dark:text-lightGrey">{{
          "DISCUSSION.MODERATED" | translate
        }}</span>
        } @else if (thread.comment) {
        <div
          class="mt-1.5"
          [appDiscussionGesture]="!deleting"
          (reactionHold)="originalReactions.show()"
          (reactionGem)="originalReactions.gem()"
        >
          <app-discussion-text
            [text]="thread.comment"
            (openWork)="openWork($event)"
          ></app-discussion-text>
        </div>
        }
        <time
          class="block mt-1 text-right text-[10px] leading-[12px] text-grey dark:text-lightGrey"
          [attr.datetime]="thread.additionDate"
          >{{ thread.additionDate | date: "HH:mm" }}</time
        >
      </article>
      <div discussionActions class="text-left text-sm">
        @if (thread.comment && !thread.commentModeratedAt) {
        <app-discussion-copy
          [text]="thread.comment"
          (completed)="originalReactions.close()"
        ></app-discussion-copy>
        } @if (thread.sender._id !== userId && thread.comment &&
        !thread.commentModeratedAt) {
        <button
          type="button"
          class="block w-full min-h-[44px] rounded-xl px-1.5 text-left hover:bg-primary/10 focus-visible:outline-primary"
          (click)="originalReactions.close(); showReport()"
        >
          {{ "DISCUSSION.REPORT" | translate }}
        </button>
        }
      </div>
    </app-discussion-reactions>
  </app-discussion-thread>
  }
</section>
